import React from 'react'
import Todo from './Todo'

export default function TodoList({todos, toggleTodo}){
  return (
    // Maps over each of our todos
    // For each todo, it returns with a Todo element
      todos.map(todo => {
        return <Todo key={todo.id} toggleTodo={toggleTodo} todo={todo} />
      })
  )
}
